import React, { useRef, useState } from "react";
import { Badge, Card, CardHeader, Select, Table } from "@opendate-app/setlist";
import client from "../../../shared/api/client";
import { toastError } from "../../../shared/toastHelper";
import { useStaffingPermissionsContext } from "./StaffingPermissionsContext";
import { describeScope, SOURCE_LABELS } from "./staffingPermissionLabels";

const EffectivePermissionsCard = () => {
  const { permissions, members, departments, positions, paths } = useStaffingPermissionsContext();
  const [memberId, setMemberId] = useState("");
  const [summary, setSummary] = useState([]);
  const latestRequest = useRef(0);

  const preview = async (value) => {
    const request = ++latestRequest.current;
    setMemberId(value || "");
    setSummary([]);
    if (!value) return;
    try {
      const { data } = await client.get(paths.effective, { params: { team_membership_id: value } });
      if (latestRequest.current === request) setSummary(data.permissions);
    } catch (_error) {
      if (latestRequest.current === request) toastError("Could not load this person's permissions.");
    }
  };

  const scopeLabel = (row) => {
    if (!row.allowed) return "—";
    if (permissions.find((permission) => permission.key === row.permission)?.teamWide) return "Whole team";
    return describeScope(row, departments, positions);
  };

  const columns = [
    { key: "permission", header: "Permission", primary: true, render: (row) => permissions.find((permission) => permission.key === row.permission)?.label },
    {
      key: "allowed",
      header: "Access",
      render: (row) => (
        <Badge size="sm" color={row.allowed ? "success" : "gray"}>
          {row.allowed ? "Allowed" : "Not allowed"}
        </Badge>
      ),
    },
    { key: "scope", header: "Where", render: (row) => scopeLabel(row) },
    { key: "source", header: "Because of", render: (row) => SOURCE_LABELS[row.source] },
  ];

  return (
    <Card padding="md" header={<CardHeader title="Effective permissions" supportingText="Check what one person can do after their role and any overrides." />}>
      <div className="mb-3" style={{ maxWidth: 360 }}>
        <Select
          id="staffing-effective-member"
          label="Person"
          searchable
          options={members.map((member) => ({ value: member.value, label: member.label }))}
          value={memberId}
          onChange={preview}
        />
      </div>
      {summary.length > 0 && <Table columns={columns} data={summary} getRowKey={(row) => row.permission} />}
    </Card>
  );
};

export default EffectivePermissionsCard;
